import ValidationHelper from "../utilities/validation-helper";
import { Constants } from "customer-sdk/constants";
const VALIDATIONS = Constants.VALIDATIONS;
const PASSWORD_RULES = [
  { message: "Password should have 8 characters minimum.", pattern: /.{8,}/ },
  {
    message: "Password should have One uppercase letter required.",
    pattern: /[A-Z]+/,
  },
  { message: "Password should have One number required.", pattern: /[0-9]+/ },
  {
    message: "Password must contain 1 special character",
    pattern: /(?=.*[^A-Za-z0-9])+/,
  },
  {
    message: "Password should have 64 characters maximum.",
    pattern: /^.{0,64}$/,
  },
];
export const ValidateMixin = {
  methods: {
    validateString: function (value) {
      return !VALIDATIONS.STRING_VALIDATION_REGEX.test(value);
    },
    validatePassword: function (value) {
      return !!value && PASSWORD_RULES.every((rule) => rule.pattern.test(value));
    },
    validateEmail: function (email) {
      return VALIDATIONS.EMAIL_VALIDATION_REGEX.test(email);
    },
    validateNricFin: function (nricFin) {
      return VALIDATIONS.NRIC_FIN_VALIDATION_REGEX.test(nricFin);
    },
    // only validate email when field has value
    validateEmailNotEmpty: function (email) {
      return new ValidationHelper().validateEmailNotEmpty(email);
    },
    validateMalaysianIdNumber: function (idNumber) {
      return VALIDATIONS.MALAYSIAN_ID_NUMBER_VALIDATION_REGEX.test(idNumber);
    },
    validateCcEmails(ccEmails) {
      if (!ccEmails) return true;
      const emails = ccEmails.split(",");
      return emails.every((email) => VALIDATIONS.EMAIL_VALIDATION_REGEX.test(email.trim()));
    },
  },
};
